import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const METRICA_ID = 102916511;

function useYandexPageView() {
  const location = useLocation();

  useEffect(() => {
    /* ym() ֆունկցիան ավելացրել ես index.html-ի կոդով, հիմա պարզապես կանչում ենք */
    window.ym?.(METRICA_ID, "hit", location.pathname + location.search);
  }, [location]);
}

export default useYandexPageView